// @ts-nocheck
export enum CUSTOM_EVENTS {
  FILTER_BUTTON_CLICK = 'on-filter-button-click',
}
